import { IModalDescription } from '@cp/shared/modal';
import type { ClientPhotoModalProps } from '../ui/photoModal';

export const CLIENT_PHOTO_PICK_MODAL: IModalDescription<ClientPhotoModalProps> = {
  nss: 'client/photo-pick',
  loader: () => import('../ui/photoModal').then((m) => m.ClientPhotoPickModal),
};
